import React from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
import UserAvatar from './UserAvatar/UserAvatar';
import ThemeToggle from './ThemeToggle/ThemeToggle';

interface UserActionsProps {
  darkMode: boolean;
  toggleDarkMode: () => void;
}

const UserActions: React.FC<UserActionsProps> = ({ darkMode, toggleDarkMode }) => {
  return (
    <div className="flex items-center gap-4">
      {/* NotificationBell component removed */}
      <ThemeToggle darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <UserAvatar />
    </div>
  );
};

export default UserActions;